export const MINIMUM_DOCS_SHOWN = 4;
export const MINIMUM_TRANSACTIONS_SHOWN = 4;
export const MINIMUM_PAYMENTS_SHOWN = 10;

export const TRANSITION_DURATION = 300;
export const LEAKBOT_SUCCESS_TIMEOUT = 10;
